import { type ReactNode } from 'react';
import { IconButton } from '@zep-us/zus';
import { cn } from '@zep-us/zus';
import { ICON_COLOR } from '@zep-us/zus/tokens';
import { ArrowUpIcon, PlusIcon, SquareSmallFillIcon } from '@zep-us/zus-icons';
import { useAiBuilderChatCopy } from '../hooks/useAiBuilderChatCopy';
type AiBuilderComposerControlBarProps = {
  attachmentPresent: boolean;
  canOpenFilePicker: boolean;
  canSubmit: boolean;
  canUseSourceAttachment: boolean;
  hasActiveTurn?: boolean;
  isGenerating: boolean;
  leftAccessory?: ReactNode;
  onOpenFilePicker: () => void;
  remainingTurnsLabel: string | null;
};
export const AiBuilderComposerControlBar = ({
  attachmentPresent,
  canOpenFilePicker,
  canSubmit,
  canUseSourceAttachment,
  hasActiveTurn = false,
  isGenerating,
  leftAccessory,
  onOpenFilePicker,
  remainingTurnsLabel
}: AiBuilderComposerControlBarProps) => {
  const copy = useAiBuilderChatCopy();
  return <div className="flex w-full items-end justify-between gap-xs" data-sentry-component="AiBuilderComposerControlBar" data-sentry-source-file="AiBuilderComposerControlBar.tsx">
      <div className="flex min-w-0 flex-1 items-center gap-2xs">
        <IconButton type="button" variant="outlined" intent="neutral" size="sm" rounded="default" aria-label={copy.composer.addSourceAriaLabel} disabled={!canOpenFilePicker || !canUseSourceAttachment || hasActiveTurn || attachmentPresent} onClick={onOpenFilePicker} data-sentry-element="IconButton" data-sentry-source-file="AiBuilderComposerControlBar.tsx">
          <PlusIcon size="md" data-sentry-element="PlusIcon" data-sentry-source-file="AiBuilderComposerControlBar.tsx" />
        </IconButton>
        {leftAccessory}
      </div>

      <div className="flex shrink-0 items-center gap-md">
        {remainingTurnsLabel && <span className="shrink-0 whitespace-nowrap text-body-sm-semibold text-neutral">
            {remainingTurnsLabel}
          </span>}
        <IconButton type="submit" variant="contained" intent="strong" size="sm" rounded="full" className={cn(!isGenerating && !canSubmit && '!bg-gray-300')} aria-label={isGenerating ? copy.composer.cancelGenerationAriaLabel : copy.composer.sendAriaLabel} disabled={!isGenerating && !canSubmit} data-sentry-element="IconButton" data-sentry-source-file="AiBuilderComposerControlBar.tsx">
          {isGenerating ? <SquareSmallFillIcon size="md" fill={ICON_COLOR.inverse} /> : <ArrowUpIcon size="md" fill={ICON_COLOR.inverse} />}
        </IconButton>
      </div>
    </div>;
};